window.matchesCartVariant = function (product, widgetProducts) {
  // Upsell items that come in only ONE colour: always show them, and never let
  // their own cart line influence the colour matching for everything else.
  const COLOR_AGNOSTIC_HANDLES = ['vessel-spatula', 'vessel-cleaning-tool'];

  const handle = ((product && product.handle) || '').trim().toLowerCase();
  if (COLOR_AGNOSTIC_HANDLES.includes(handle)) return true;

  // Read cart colours, skipping any cart line belonging to a colour-agnostic product.
  const cartTitles = Array.from(document.querySelectorAll('.rebuy-cart__flyout-item'))
    .filter((item) => {
      const itemClasses = item.className.toLowerCase();
      return !COLOR_AGNOSTIC_HANDLES.some((h) => itemClasses.includes('product-' + h));
    })
    .map((item) => {
      const el = item.querySelector('.rebuy-cart__flyout-item-variant-title');
      return el ? el.textContent.trim().toLowerCase() : '';
    })
    .filter(Boolean);

  if (!cartTitles.length) return true;

  const widgetColors = (widgetProducts || [])
    .map((p) => ((p.selected_variant && p.selected_variant.title) || '').trim().toLowerCase())
    .filter(Boolean);

  const anchorColor = cartTitles.find((c) =>
    widgetColors.some((wc) => wc.includes(c) || c.includes(wc))
  );

  if (!anchorColor) return false;

  const variantTitle = ((product && product.selected_variant && product.selected_variant.title) || '')
    .trim()
    .toLowerCase();

  return variantTitle.includes(anchorColor) || anchorColor.includes(variantTitle);
};